@if (mensaje) {
    <div
        class="comunicacion-row"
        [class.comunicacion-row--side-denunciante]="side === 'DENUNCIANTE'"
        [class.comunicacion-denunciante]="mensaje.actor === 0"
        [class.comunicacion-denunciante-modificado]="mensaje.actor === 3"
        [class.comunicacion-gestor]="mensaje.actor === 1"
        [class.comunicacion-sistema]="mensaje.actor === 2"
    >
        <div class="comunicacion-bubble-and-status">
            <div
                class="comunicacion-mensaje-wrapper"
                [class.comunicacion-mensaje-wrapper--no-radius-bottom]="(mensaje.documents?.length ?? 0) > 0"
            >
                @if (mensaje.actor === 2) {
                    <!-- <p class="comunicacion-sistema-dots">···</p> -->
                }
                <div class="comunicacion-header-row">
                    <p class="comunicacion-header">
                        <strong>{{ getHeaderLabel(mensaje.actor) }}, {{ formatDate(mensaje.creationDate) }}</strong>
                    </p>
                    @if (canEditOrDelete() && !editingMessage && !showDeleteConfirm) {
                        <div class="comunicacion-header-actions">
                            <button
                                type="button"
                                mat-icon-button
                                class="comunicacion-edit-btn"
                                (click)="startEditing()"
                                title="Editar mensaje"
                            >
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button
                                type="button"
                                mat-icon-button
                                class="comunicacion-delete-btn"
                                (click)="onEliminarClick()"
                                title="Eliminar mensaje"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    }
                </div>

                @if (editingMessage) {
                    <div class="comunicacion-edit-form">
                        <textarea
                            class="comunicacion-edit-textarea"
                            [(ngModel)]="editedMensajeText"
                            [maxlength]="MAX_MENSAJE"
                            rows="4"
                            placeholder="Editar mensaje (mínimo 20, máximo 1000 caracteres)"
                        ></textarea>
                        <span class="comunicacion-edit-chars">
                            {{ (editedMensajeText ?? "").length }} / {{ MAX_MENSAJE }}
                            @if (
                                (editedMensajeText ?? "").trim().length > 0 &&
                                (editedMensajeText ?? "").trim().length < MIN_MENSAJE
                            ) {
                                <span class="comunicacion-edit-chars-warn"> (mínimo {{ MIN_MENSAJE }} caracteres)</span>
                            }
                        </span>
                        <div class="comunicacion-edit-form-actions">
                            <button type="button" mat-button (click)="cancelEditing()">Cancelar</button>
                            <button
                                type="button"
                                mat-raised-button
                                color="primary"
                                [disabled]="!canSubmitEdit()"
                                (click)="submitModificacion()"
                            >
                                Enviar modificación
                            </button>
                        </div>
                    </div>
                } @else {
                    <p class="comunicacion-mensaje-text">{{ mensaje.mensaje }}</p>
                }

                @if (showDeleteConfirm) {
                    <div class="comunicacion-delete-confirm">
                        <span class="comunicacion-delete-confirm-text">¿Eliminar este mensaje?</span>
                        <div class="comunicacion-delete-confirm-actions">
                            <button type="button" mat-button (click)="cancelDeleteConfirm()">Cancelar</button>
                            <button type="button" mat-raised-button color="warn" (click)="confirmarEliminacion()">
                                Eliminar
                            </button>
                        </div>
                    </div>
                }

                @if (mensaje.actor === 2) {
                    <!-- <p class="comunicacion-sistema-dots">···</p> -->
                }
            </div>

            @if ((mensaje.actor === 0 || mensaje.actor === 1) && mensaje.documents?.length > 0) {
                <div
                    class="comunicacion-documentos"
                    [class.comunicacion-documentos--right]="
                        (mensaje.actor === 1 && side === 'RRHH') || (mensaje.actor === 0 && side === 'DENUNCIANTE')
                    "
                    [class.comunicacion-documentos--left]="
                        (mensaje.actor === 0 && side === 'RRHH') || (mensaje.actor === 1 && side === 'DENUNCIANTE')
                    "
                >
                    <button
                        type="button"
                        class="comunicacion-documentos-toggle"
                        (click)="toggleDocumentos()"
                        [attr.aria-expanded]="documentosExpanded"
                    >
                        <mat-icon class="toggle-icon">{{
                            documentosExpanded ? "expand_less" : "expand_more"
                        }}</mat-icon>
                        <span>Archivos adjuntos ({{ getDocumentosCount() }})</span>
                    </button>
                    @if (documentosExpanded) {
                        @if (getDocumentosCount() > 0) {
                            <div class="comunicacion-documentos-table-wrap">
                                <table class="comunicacion-documentos-table">
                                    <colgroup>
                                        <col class="col-icon" />
                                        <col class="col-name" />
                                        @if (!isSugerencia) {
                                            <col class="col-tipo" />
                                        }
                                        <col class="col-size" />
                                        <col class="col-actions" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th style="text-align: center !important">Icono</th>
                                            <th style="text-align: left !important">Nombre</th>
                                            @if (!isSugerencia) {
                                                <th style="text-align: left !important">Tipo</th>
                                            }
                                            <th style="text-align: left !important">Tamaño</th>
                                            <th style="text-align: center !important"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (doc of mensaje.documents; track doc.hash) {
                                            <tr>
                                                <td class="doc-icon-cell">
                                                    <mat-icon>{{ doc.icon_class || "insert_drive_file" }}</mat-icon>
                                                </td>
                                                <td class="doc-name-cell">{{ doc.nombreDocumento || "-" }}</td>
                                                @if (!isSugerencia) {
                                                    <td class="doc-type-cell">{{ getTipoDocumentoName(doc.tipo) }}</td>
                                                }
                                                <td class="doc-size-cell">{{ formatFileSize(doc.size) }}</td>
                                                <td class="doc-actions-cell">
                                                    <button
                                                        type="button"
                                                        mat-icon-button
                                                        (click)="onVerDocumento(doc)"
                                                        title="Ver archivo"
                                                        class="doc-view-btn"
                                                    >
                                                        <mat-icon>visibility</mat-icon>
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        } @else {
                            <p class="comunicacion-documentos-empty">No hay archivos adjuntos</p>
                        }
                    }
                </div>
            }
            @if (mensaje.actor === 0 && side === "DENUNCIANTE") {
                <div class="comunicacion-status comunicacion-status-right">
                    @if (mensaje.leidoRRHH === 0) {
                        <mat-icon class="comunicacion-check single">done</mat-icon>
                        <span>Enviado</span>
                    } @else {
                        <mat-icon class="comunicacion-check double">done_all</mat-icon>
                        <span>Leído por gestores</span>
                    }
                </div>
            }
            @if (mensaje.actor === 1 && side === "RRHH") {
                <div class="comunicacion-status comunicacion-status-right">
                    @if (mensaje.leidoDenunciante === 0) {
                        <mat-icon class="comunicacion-check single">done</mat-icon>
                        <span>Enviado</span>
                    } @else {
                        <mat-icon class="comunicacion-check double">done_all</mat-icon>
                        @if (isSugerencia) {
                            <span>Leído por solicitante</span>
                        } @else {
                            <span>Leído por denunciante</span>
                        }
                    }
                </div>
            }
        </div>
    </div>
}
